export default __webpack_public_path__ + "static/media/mebloscianki3.8fa41678.jpg";